module.exports = __webpack_public_path__ + "media/images/pen_red-11aa32d3.png";